module.exports = __webpack_public_path__ + "static/media/google.909769d4.svg";